import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { FeaturesSection } from '../components/FeaturesSection';
import { ReviewExcerpts } from '../components/ReviewExcerpts';
import { NearestLocationFinder } from '../components/NearestLocationFinder';
import { FAQSection } from '../components/FAQSection';
import { SocialMediaSection } from '../components/SocialMediaSection';
export function AboutPage() {
  return <>
      <PageHeader title="About Us" backgroundImage="https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1920&q=80" data-id="element-724" />
      <FeaturesSection data-id="element-725" />
      <ReviewExcerpts data-id="element-726" />
      <SocialMediaSection data-id="element-727" />
      <FAQSection data-id="element-728" />
      <NearestLocationFinder data-id="element-729" />
    </>;
}